<template>
  <div class="timeline small">
    <div class="point" v-for="point in points" :key="point.key">
      <div class="image-wrapper">
        <img class="image" :src="point.info.image" alt="" />
      </div>
      <div class="content-wrapper">
        <h2>{{ point.info.year }}</h2>
        <p>{{ point.info.description }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import points from "@/data/home";
export default {
  name: "TimelineSmall",
  data() {
    return {
      points
    };
  }
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";
.timeline.small {
  grid-area: timeline-small;
  padding: 0 1.5rem;

  width: 100%;

  display: flex;
  overflow-y: scroll;
}

.point {
  overflow: hidden;
  min-width: calc(50% - 0.75rem);
  margin: 0 0.75rem;
  position: relative;
  display: flex;
  align-items: flex-end;
}

.point:first-of-type {
  margin-left: 0;
}

.image-wrapper {
  z-index: 0;
  position: absolute;
  top: 0;
  left: 0;
}
.image {
  width: 100%;
  height: auto;
  display: block;
}

.content-wrapper {
  z-index: 2;
  padding: 1rem;
  background: $gold;
}

.content-wrapper h2 {
  margin: 0;
}

.content-wrapper p {
  margin: 1rem 0 0 0;
}

@media screen and (min-width: 1025px) {
  .timeline.small {
    display: none;
  }
}

@media screen and (max-width: 767px) {
  .timeline.small {
    padding: 1rem 0;
  }

  .point {
    min-width: 100%;
  }
}
</style>
